import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    MatCell, MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef,
    MatTable
} from "@angular/material/table";
import { MatAnchor, MatButton } from "@angular/material/button";
import { RouterLink } from "@angular/router";
import { AuthService } from "./auth.service";

@NgModule({
    declarations: [
    ],
    exports: [
    ],
    imports: [
        CommonModule,
        MatTable,
        MatColumnDef,
        MatHeaderCellDef,
        MatCell,
        MatHeaderCell,
        MatHeaderRow,
        MatRow,
        MatCellDef,
        MatHeaderRowDef,
        MatRowDef,
        MatAnchor,
        MatButton,
        RouterLink
    ],
    providers: [ AuthService ]
})
export class AuthModule { }
